import React from 'react';
import { Form, Col, Row, Input, Select, Divider, Switch, Progress, Button, Icon } from 'antd';

import InputCurrency, { currency2Float } from '~/components/UI/InputCurrency';

import SelectWithAdd from '~/components/UI/SelectWithAdd';
import { InstallmentsTable } from '../Tables/InstallmentsTable';
import { PERMISSIONS } from '~/constants/permissions.constants';

import AssignTo from '~/components/AssignTo';
import Stages from '../components/Stages';

const { Option, OptGroup } = Select;

class FormClose extends React.Component {
  state = {
    default: {
      id: null,
      customer_id: null,
      description: null,
      amount: 0.00,
      create_payments: false,
      paid_off: false,
      stages: {}
    }
  };

  createBills = (val) => {

    if (val) {
      this.props.openBillForm({
        task_name: 'Encerramento da Empresa',
        total: this.props.form.getFieldValue('amount')
      });
    } else {
      this.props.setBillsData(null);
    }
  }

  getInitialCustomer = (data) => {
    if (!data.deleted_customer) {
      return data.customer_id;
    }

    return `${data.deleted_customer.cod} - ${data.deleted_customer.name}`;
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { customers, user, form } = this.props;

    const data = {
      ...this.state.default,
      ...this.props.data
    };

    return (
      <Form>
        <Row gutter={16} className="mb-30">
          {(data.customer_id === null || data.id === null) && (
          <Col span={24}>
            <Form.Item label="Empresa">
              {getFieldDecorator('customer_id', data.customer_id ? {
                initialValue: this.getInitialCustomer(data),
                rules: [{ required: true, message: 'Por favor selecione uma opção!' }],
              } : {
                rules: [{ required: true, message: 'Por favor selecione uma opção!' }],
              })(
                <SelectWithAdd
                  placeholder="Selecione uma empresa"
                  disabled={!!data.id}
                  onChange={val => this.setState({ default: { ...this.state.default, customer_id: val } })}
                  setForm={(val) => this.props.form.setFieldsValue({ customer_id: val })}
                >
                  <OptGroup label="Clientes">
                    {customers.filter(row => row.is_customer).map(row =>
                      <Option value={row.id} key={row.id}>{row.cod ? `${row.cod} - ${row.name}` : row.name}</Option>
                    )}
                  </OptGroup>
                  <OptGroup label="Não Clientes">
                    {customers.filter(row => !row.is_customer).map(row =>
                      <Option value={row.id} key={row.id}>{row.cod ? `${row.cod} - ${row.name}` : row.name}</Option>
                    )}
                  </OptGroup>
                </SelectWithAdd>
              )}
            </Form.Item>
          </Col>
          )}
          <Col span={24}>
            <Form.Item label="Solicitação da diretoria">
              {getFieldDecorator('description', {
                initialValue: data.description,
                rules: [{ required: true, message: 'Descreva detalhes sobre o encerramento' }],
              })(
                <Input.TextArea rows={4} placeholder="Descreva detalhes sobre o encerramento" disabled={(data.id != null && data.created_by !== user.id) && data.description !== null} />
              )}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              {getFieldDecorator('stages', {
                initialValue: data.stages,
              })(
                <Stages initial={data.stages} category={this.props.category} taskId={data.id} notes={data.stage_notes} stageList={data.stage_list} />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <AssignTo form={form} initialValue={data.assigned_to} />
          </Col>
          <Col span={24}>
            <Form.Item label="Resposta do executor">
              {getFieldDecorator('answer', {
                initialValue: data.answer,
              })(
                <Input.TextArea rows={4} placeholder="Descreva detalhes adicionais" />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default FormClose;